module.exports = __webpack_public_path__ + "static/media/app01_eng.5d26729c.png";